export const isEUIValid = (devEUI: string) => {
  const VALIDLENGTH = 16
  const re = /^[0-9A-F]+$/ // /^[0-9A-F]{16}$/ to include length in regex
  if (re.test(devEUI) && devEUI.length === VALIDLENGTH) {
    return true
  }
  return false
}
